var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoTransporte01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    d: "M26.7,33.7c-2.9,0-5.2-2.3-5.2-5.2h-7c0,2.9-2.3,5.2-5.2,5.2s-5.2-2.3-5.2-5.2c-1.9,0-3.5-1.6-3.5-3.5V5.8 c0-1.9,1.6-3.5,3.5-3.5h19.2c1,0,1.7,0.8,1.7,1.7v3.5h2.5c1.2,0,2.4,0.6,3,1.7l4.7,7.9c0.2,0.3,0.2,0.6,0.2,0.9v7 c0,1.9-1.6,3.5-3.5,3.5C31.9,31.3,29.6,33.7,26.7,33.7z M26.7,26.7c-1,0-1.7,0.8-1.7,1.7c0,1,0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7 C28.5,27.5,27.7,26.7,26.7,26.7z M9.3,26.7c-1,0-1.7,0.8-1.7,1.7c0,1,0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7C11,27.5,10.3,26.7,9.3,26.7z  M26.7,23.2c1.5,0,2.9,0.6,3.9,1.7h1.4v-5.2h-7v3.8C25.5,23.3,26.1,23.2,26.7,23.2z M9.3,23.2c1.5,0,2.9,0.6,3.9,1.7h8.3V5.8H4.1V25 h1.4C6.4,23.9,7.8,23.2,9.3,23.2z M25,11v5.2h5.6L27.5,11H25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTransporte01);
export default __webpack_public_path__ + "static/media/ico-transporte-01.5028bca653dd46b36efd5179c689a4ac.svg";
export { ForwardRef as ReactComponent };